import requiredAppConfig from "./requiredAppConfig.json";

const runtimeConfig =
  typeof window !== "undefined" && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

const buildTimeConfig = {
  VUE_APP_MASTERS_API_URL: process.env.VUE_APP_MASTERS_API_URL,
  VUE_APP_CAMPAIGNS_API_URL: process.env.VUE_APP_CAMPAIGNS_API_URL,
  VUE_APP_USERS_API_URL: process.env.VUE_APP_USERS_API_URL,
  VUE_APP_AUTH_API_URL: process.env.VUE_APP_AUTH_API_URL,
  VUE_APP_ASSESSMENT_API_URL: process.env.VUE_APP_ASSESSMENT_API_URL,
  VUE_APP_QUESTIONS_API_URL: process.env.VUE_APP_QUESTIONS_API_URL,
  VUE_APP_ASSESSMENT_ENGINE_API_URL: process.env.VUE_APP_ASSESSMENT_ENGINE_API_URL,
  VUE_APP_PSYCHOMETRY_API_URL: process.env.VUE_APP_PSYCHOMETRY_API_URL,
  VUE_APP_NOTIFICATION_API_URL: process.env.VUE_APP_NOTIFICATION_API_URL,
  VUE_APP_FRONTEND_URL: process.env.VUE_APP_FRONTEND_URL,
  VUE_APP_ADMIN_URL: process.env.VUE_APP_ADMIN_URL,
  VUE_APP_IS_PRODUCTION: process.env.VUE_APP_IS_PRODUCTION,
  VUE_APP_TUSD_ENDPOINT_URL: process.env.VUE_APP_TUSD_ENDPOINT_URL,
  VUE_APP_FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY,
  VUE_APP_FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  VUE_APP_FIREBASE_DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  VUE_APP_FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  VUE_APP_FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  VUE_APP_FIREBASE_MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  VUE_APP_FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID,
  VUE_APP_FIREBASE_MEASUREMENT_ID: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
  VUE_APP_FCM_TOKEN: process.env.VUE_APP_FCM_TOKEN,
  VUE_APP_GOOGLE_MAP_API_KEY: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
  VUE_APP_KEYCLOAK_URL: process.env.VUE_APP_KEYCLOAK_URL,
  VUE_APP_KEYCLOAK_REALM: process.env.VUE_APP_KEYCLOAK_REALM,
  VUE_APP_KEYCLOAK_CLIENT_ID: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  VUE_APP_MESTA_REDIRECT_URL: process.env.VUE_APP_MESTA_REDIRECT_URL,
};

const getConfigValue = (key) => {
  const runtimeValue = runtimeConfig[key];

  if (runtimeValue !== undefined && runtimeValue !== null && `${runtimeValue}`.trim() !== "") {
    return runtimeValue;
  }

  const buildTimeValue = buildTimeConfig[key];
  return buildTimeValue !== undefined && buildTimeValue !== null ? buildTimeValue : "";
};

const appConfig = Object.freeze(
  Object.keys(buildTimeConfig).reduce((config, key) => {
    config[key] = getConfigValue(key);
    return config;
  }, {})
);

const missingEntry = requiredAppConfig.find(({ key }) => {
  const value = appConfig[key];
  return value === undefined || value === null || String(value).trim() === "";
});

if (missingEntry) {
  throw new Error(`Missing App configuration value: "${missingEntry.name}"`);
}

export const getBooleanConfig = (key, fallback = false) => {
  const value = appConfig[key];

  if (typeof value === "boolean") {
    return value;
  }

  if (value === "" || value === undefined || value === null) {
    return fallback;
  }

  return String(value).toLowerCase() === "true";
};

export default appConfig;
